import api from '../api';

const normalizeTemplate = (template = {}) => ({
  ...template,
  standards: Array.isArray(template?.standards) ? template.standards : [],
  config: template?.config && typeof template.config === 'object' ? template.config : {},
});

const unwrapPayload = (responseData) => {
  if (Array.isArray(responseData)) return responseData;
  if (Array.isArray(responseData?.data)) return responseData.data;
  if (responseData?.data && typeof responseData.data === 'object') return responseData.data;
  return responseData;
};

export const listAuditOutputTemplates = async (params = {}) => {
  const response = await api.get('/audit/output-templates', { params });
  const unwrapped = unwrapPayload(response?.data);
  const payload = Array.isArray(unwrapped)
    ? unwrapped
    : unwrapped?.content || [];
  return payload.map(normalizeTemplate);
};

export const getAuditOutputTemplate = async (id) => {
  const response = await api.get(`/audit/output-templates/${id}`);
  return normalizeTemplate(unwrapPayload(response?.data) || {});
};

export const createAuditOutputTemplate = async (payload) => {
  const response = await api.post('/audit/output-templates', payload);
  return normalizeTemplate(unwrapPayload(response?.data) || {});
};

export const updateAuditOutputTemplate = async (id, payload) => {
  const response = await api.put(`/audit/output-templates/${id}`, payload);
  return normalizeTemplate(unwrapPayload(response?.data) || {});
};

export const deleteAuditOutputTemplate = async (id) => {
  await api.delete(`/audit/output-templates/${id}`);
};
